export default "__VITE_ASSET__73fe45eb__"